// formEngineChipHelpers — display-name lookup for the DDL form-corner engine
// chip.
//
// Split out of `FormEngineChip.tsx` (a non-TSX sibling) for the same reason as
// `sequenceFormHelpers.ts`: a TSX file that exports both a component and a
// runtime helper trips the `react-refresh/only-export-components` lint rule.
//
// The chip used to render the raw `SqlEngine` id under `uppercase`, so it read
// "POSTGRES" / "MSSQL". `@/core/engines` is the canonical engine registry, and
// its `shortName` is the user-facing spelling ("PostgreSQL", "SQL Server", …).
// Note `SqlEngine` is the grammar-layer union (`'postgres'`), which has to be
// bridged to `DatabaseEngineId` (`'pgsql'`) before the registry lookup.

import {
  getEngineDisplayInfo,
  sqlEngineToDatabaseEngineId,
} from '../../../../../core/engines';
import type { SqlEngine } from '../../../../sql-grammar/model';

/** Display short name for a grammar-layer `SqlEngine` (e.g. `mssql` → `SQL Server`). */
export function engineChipLabel(engine: SqlEngine): string {
  return getEngineDisplayInfo(sqlEngineToDatabaseEngineId(engine))?.shortName ?? engine;
}
